import React from 'react'
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";

export default function Projects() {
    return (
        <div className='grid gap-4'>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">Hostel Management Website</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Hostel Management MERN Application for GCECT Boys Hostel</span>
                                    <Link to="https://hm-tbk3.onrender.com/" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Dec 19, 2024</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">Library Management System</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Library Management Application using MERN stack</span>
                                    <Link to="https://lib-mangmnt.netlify.app/" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Dec 19, 2024</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">AutoCast</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Machine Learning Model to predict Car Prices</span>
                                    <Link to="https://github.com/Amarjit-Khan/Car-Price-Predictor.git" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Jun 21, 2024</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">ValuMate</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Machine Learning Model to predict Real Estate Prices</span>
                                    <Link to="https://github.com/Amarjit-Khan/Real-Estate-Price-Predictor.git" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Jun 21, 2024</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">GetBus</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Online Bus Ticket Booking System using Php and MySQL</span>
                                    <Link to="https://github.com/Amarjit-Khan/GetBus---online-bus-booking-website.git" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">May 11, 2023</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">BlogZilla</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Full Stack blog application using MERN Stack</span>
                                    <Link to="https://github.com/Amarjit-Khan/Blogzilla" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">July 26, 2022</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4'>
                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">Find My Train</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">React based website using a live search filter</span>
                                    <Link to="https://github.com/Amarjit-Khan/Find_My_Train" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Feb 27, 2022</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">TextUtills</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Text Editing website application using ReactJS</span>
                                    <Link to="https://github.com/Amarjit-Khan/Textutills-TextEditor" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Feb 21, 2022</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className="group border border-stone-800/90 p-[0.4rem] rounded-lg">
                    <section className="relative w-full flex flex-col justify-start gap-0">
                        <div className="rounded-lg px-4 py-2 ease-in duration-200 no-underline">
                            <div className="w-full h-full">
                                <div className="m-0 font-semibold eduheder mb-1">iNotes</div>
                                <div className="flex align-center gap-1 flex-col">
                                    <span className="text-zinc-300 m-0">Notes Management System coded in core PHP and MySql</span>
                                    <Link to="https://github.com/Amarjit-Khan/iNotes.git" className="text-zinc-400 m-0 group-hover:text-[hsla(32,98%,83%,0.9)]">View</Link>
                                    <span className="text-zinc-300 text-xs m-0">Feb 9, 2022</span>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <Link to="https://github.com/Amarjit-Khan?tab=repositories" className='m-0 font-semibold mb-1 ml-6 flex gap-2 items-center text-gray-400 hover:text-[hsla(32,98%,83%,0.9)]'>
                View more
                <FaExternalLinkAlt className='font-semibold text-xs' />
            </Link>
        </div>
    )
}